import React, { useState, useEffect } from 'react';
import { Grid, Tooltip } from '@quillbot/design-system';
import QuillLocalStorage from 'core/utils/localStorageClient';
import { useSelector } from 'react-redux';
import { RootState } from 'src/_common/models/redux/store';
// import { feather } from 'public/images/svgPath.json';
import NewQuillBtn from '@Common/quillElements/button/NewQuillBtn';
import { GLOBAL_CONSTANTS } from '@Common/constants';

interface IProps {
  inProgress: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isRequill?: boolean;
}

function QuillBtn(props: IProps) {
  const [buttonTitle, setButtonTitle] = useState('Summarize');
  const isExtension = useSelector((state: RootState) => state.common.platform.isExtension);
  const isDesktop = useSelector((state: RootState) => state.common.platform.isDesktop);
  const isMac = useSelector((state: RootState) => state.common.platform.isMac);

  const getTitle = () => {
    let tooltipText = '';
    if (QuillLocalStorage.getInstance().get('showToolTips', 'true') === 'true') {
      tooltipText = props.isRequill ? 'ReSummarize' : 'Summarize';
      if (isDesktop && !isExtension) {
        tooltipText += isMac ? GLOBAL_CONSTANTS.CMD_ENTER : GLOBAL_CONSTANTS.CTRL_ENTER;
      }
    }
    return tooltipText;
  };

  useEffect(() => {
    setButtonTitle(getTitle());
  });

  // const featherProps = feather as SvgIconProps;
  return (
    <Tooltip arrow title={buttonTitle} placement="bottom">
      <Grid>
        <NewQuillBtn
          className="quillArticleBtn"
          color="primary"
          variant="contained"
          disabled={props.inProgress}
          style={{
            borderRadius: isExtension ? '4px' : undefined,
            padding: isExtension ? '5px 21px' : undefined,
          }}
          onClick={props.onClick}
          buttonText={props.isRequill ? 'ReSummarize' : 'Summarize'}
        />
      </Grid>
    </Tooltip>
  );
}

export default QuillBtn;
